import { render, staticRenderFns } from "./BusinessUnitAdd.vue?vue&type=template&id=08fce27b&scoped=true"
import script from "./BusinessUnitAdd.vue?vue&type=script&lang=js"
export * from "./BusinessUnitAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fce27b",
  null
  
)

export default component.exports